import { SkinBase } from '../mvc/SkinBase';
export class BaseToastItem extends SkinBase {
    constructor() {
        super(...arguments);
        this.$isEnd = false;
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    setMessage(message) {
        //
    }
}
